<template>
  <div class="columns">
    <div class="column">
      <b-field label="ID Aufschlagssatzstaffel">
        <b-input type=number maxlength="255" v-model="extraChargeId"></b-input>
      </b-field>
    </div>
    <div class="column">
      <b-field label="Von">
        <div>
          <label for="monat">Tag: </label>
          <select v-model="selectedDayFrom" @change="sendConditionData">
            <!-- Tage von 1 bis 31 -->
            <option v-for="day in days" :key="day" :value="day">{{ day }}</option>
          </select>
          <label for="monat"> Monat: </label>
          <select v-model="selectedMonthFrom" @change="sendConditionData">
            <!-- Monate von 1 bis 12 -->
            <option v-for="month in months" :key="month" :value="month">{{ month }}</option>
          </select>
        </div>
      </b-field>
    </div>
    <div class="column">
      <b-field label="Bis">
        <div>
          <label for="monat">Tag: </label>
          <select v-model="selectedDayTo" @change="sendConditionData">
            <!-- Tage von 1 bis 31 -->
            <option v-for="day in days" :key="day" :value="day">{{ day }}</option>
          </select>
          <label for="monat"> Monat: </label>
          <select v-model="selectedMonthTo" @change="sendConditionData">
            <!-- Monate von 1 bis 12 -->
            <option v-for="month in months" :key="month" :value="month">{{ month }}</option>
          </select>
        </div>
      </b-field>
    </div>
  </div>
</template>

<script>

export default {
  props: ['item'],
  data() {
    return {
      extraChargeId: 0,
      selectedDayFrom: 1,
      selectedMonthFrom: 1,
      selectedDayTo: 1,
      selectedMonthTo: 1,
      days: Array.from({length: 31}, (_, i) => i + 1), // Array mit den Tagen von 1 bis 31
      months: Array.from({length: 12}, (_, i) => i + 1), // Array mit den Monaten von 1 bis 12
    }
  },
  watch: {
    extraChargeId: {
      handler: "sendConditionData"
    },
  },
  mounted() {
    if (this.item && this.item.data) {
      console.log('Component ruleConditionPackageAndQuantity mounted.');
      this.selectedDayFrom = this.item.data.selectedDayFrom,
          this.selectedMonthFrom = this.item.data.selectedMonthFrom,
          this.selectedDayTo = this.item.data.selectedDayTo,
          this.selectedMonthTo = this.item.data.selectedMonthTo
      this.extraChargeId = this.item.data.extraChargeId
    }
  },
  methods: {
    sendConditionData: function () {
      console.log('sendConditionData')
      let conditionData = {
        type: 2,
        selectedDayFrom: this.selectedDayFrom,
        selectedMonthFrom: this.selectedMonthFrom,
        selectedDayTo: this.selectedDayTo,
        selectedMonthTo: this.selectedMonthTo,
        extraChargeId: Number(this.extraChargeId),
      }
      this.$emit('setConditionData', conditionData)
    },
  },
}

</script>
